<template>
  <q-page>
    <div class="q-ma-md render-container" v-html="renderedMd"></div>
  </q-page>
</template>

<script>
import { updateCustomMd } from '../../js/customMdParse/customMdParse'

export default {
  name: 'home',
  data () {
    return {
      content: `# Note Templates
This page still needs to be written! :(
`,
      renderedMd: '',
      componentDefinitionAry: []
    }
  },
  mounted () {
    this.renderedMd = updateCustomMd(this.content || '', this.componentDefinitionAry, this.item, null, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
    this.renderedMd = this.renderedMd + '<div style="width: 100%; height: 25vh;"></div>' // eslint-disable-line vue/no-side-effects-in-computed-properties
  }
}
</script>

<style scoped>

</style>
